import React from 'react';
import assign from 'object-assign';
// elements
import Form from '../Common/Form.react';
import LinearProgress from 'material-ui/LinearProgress';
import MenuItem from 'material-ui/MenuItem';
import SelectField from '../Common/SelectField';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';
// business logic
import AccessGroupActions from '../../actions/AccessGroupActionCreator';
import AccessGroupStore from '../../stores/AccessGroupStore';

const AccessGroupForm = React.createClass({

    getInitialState: function() {
        return {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            details: {
                id: '',
                name: '',
                description: '',
                parentId: 0,
            },
            accessGroups: [],
            loading: true
        };
    },

    componentDidMount: function() {
        AccessGroupStore.addChangeListener(this.onAccessGroupsChange);
        AccessGroupActions.getAll();
    },
    
    componentWillUnmount: function() {
        AccessGroupStore.removeChangeListener(this.onAccessGroupsChange);
    },
    
    errorMessages: {
        isWords: 'Please only use letters',
        minLength: 'Please use at least 2 letters',
        maxLength: 'Text is too long'
    },
    
    render: function() {

        let formProps = {
            title: (!this.state.isEdit ? 'New' : 'Edit'),
            onSave: this.onSave,
            redirectTo: '/dashboard/accessgroups'
        };
        let progress;
        if (this.state.loading) {
            progress = <LinearProgress mode="indeterminate" />;
        }
        let parentSelect;
        if (this.state.loading || this.state.accessGroups.length > 0) {
            parentSelect = <SelectField
                name="parentId"
                value={this.state.details.parentId}
                floatingLabelText="Parent"
            >
                {this.state.accessGroups}
            </SelectField>
        }
        return (
            <Form {...formProps} >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            floatingLabelText="Name"
                            hintText="Name"
                            validations={{isWords: true, minLength:2, maxLength:120}}
                            validationErrors={this.errorMessages}
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            floatingLabelText="Description"
                            hintText="Description"
                            multiLine={true}
                            rowsMax={8}
                        />
                        {parentSelect}
                    </CardText>
                    {progress}
                </Card>
            </Form>
        );
    },
    
    // prepare data
    
    onAccessGroupsChange: function() {
        let accessGroups = AccessGroupStore.getTree();
        if (accessGroups !== undefined) {
            let state = assign(this.state, { accessGroups: this.getParentDropdown(accessGroups) });

            if (this.state.isEdit) {
                let details = AccessGroupStore.getById(this.props.routeParams.id);
                if (details !== undefined) {
                    details.parentId = Number(details.parentId || 0); // type matching
                    state = (assign(state, { details: details }));
                }
            } else {
                state.details.parentId = 0;
            }
            state.loading = false;
            this.setState(state);
        }
    },
    
    // handle form
    
    onSave: function(model) {
        if(!this.state.isEdit) {
            return AccessGroupActions.save(model);
        } else {
            return AccessGroupActions.update(this.props.routeParams.id, model);
        }
    },
    
    // misc
    
    getParentDropdown: function(categories) {
        let list = [];
        let id = (this.props.routeParams.id || -1);
        let walker = function(level) {
            let walkLevel = level;
            let levelClass = 'access-group-level-' + walkLevel;
            return function(accesGroup) {
                if (id != accesGroup.id) { // filter out subtree
                    let name = '';
                    for (let i = 0; i < walkLevel; ++i) { name += '| '; }
                    name += accesGroup.name;
                    list.push(
                        <MenuItem key={accesGroup.id}
                                  className={levelClass}
                                  value={accesGroup.id}
                                  primaryText={name} />
                    );
                    accesGroup.children.forEach(walker(walkLevel + 1));
                }
            };
        };
        let w = walker(0);
        categories.forEach(w);
        return list;
    },
    
    
});

export default AccessGroupForm;
